<script>
import {mapGetters} from "vuex";
import SectionMap_layer_units from "@/components/app/SectionMap_layer_units";
import {htmlToElement} from "@/lib/lib";
import consts from "@/consts";

export default {
    extends: SectionMap_layer_units,
    name: "SectionMap_layer_shipments_units",
    data() {
        return {
            showGeozoneEdit: false,// replace extends
        }
    },
    computed: {
        ...mapGetters([
            "getUnitsByIds",
            "getUnitsLmsgsByIds",
            "getShipments",
            "getShipmentsById"
        ]),
        shipmentId() {
            return this.isShowLayer ? this.routeFilter.shipmentId : undefined
        },
        shipment() {
            return this.getShipments?.find(s => s.id == this.shipmentId);
        },
        shipmentType() {
            return this.shipment?.type
        },
        unitTracking() {
            let unitId = this.shipment?.status !== 'completed' ? this.shipment?.unit_id || 0 : 0
            let ok = !!this.getUnitsLmsgsByIds[unitId] && !!this.getUnitsByIds[unitId]
            return ok ? +unitId : 0
        },
        unitsOnMap() {
            if (!this.isShowLayer) return []
            let unitsOnMap = []

            if(this.routeName == consts.routerNames.shipments_locator.main) {
                unitsOnMap = this.getUnitsOnMap
            } else
            if (this.unitTracking) unitsOnMap.push(this.unitTracking)

            return unitsOnMap
        },
        updateUnitTrackingOnMap() {
            return [this.unitTracking, ['started'].includes(this.shipment?.status) ? this.shipment?.status : ''].join('/')
        },
    },
    watch: {
        updateUnitTrackingOnMap: {
            handler: function (newUnitId, oldUnitId) {
                // if(this.$isDevelopment) console.log('SectionMap watch unitTracking', newUnitId, oldUnitId)
                if (!oldUnitId) {
                    // if(this.$isDevelopment) console.log('unitTracking', newUnitId, oldUnitId)
                }
                // if (!newUnitId) return false;
                //this.setMapBoundsByUnits([newUnitId])//????
                //this.setMarkers(this.getUnitsOnMap)
                if(this.unitTracking && this.shipment?.status === 'started') {
                    this.switchUnitTracking(newUnitId, this.getMapPaddingBounds)
                }
            },
            immediate: true,
            // deep: true
        },
    },
    methods: {
        _unitIcon(params) {
            let shipment = this.getShipments?.find(s => s.unit_id == params.id)
            let unit_icon = 'shipment__'+shipment.type
            let img_src = '/img/icons.svg#' + unit_icon;
            let html =
                '<div class="unit-marker unit-marker-has-halo">' +
                '<div class="unit-marker-svg-icon">' +
                '<svg class="svg-icon-unit-marker" xmlns="http://www.w3.org/2000/svg">' +
                '<use xlink:href="' + img_src + '"/>' +
                '</svg>' +
                '</div>' +
                '<div class="leaflet-label unit-marker-label" >' + shipment?.name + '</div>' +
                '</div>'

            html = htmlToElement(html);
            return this.L.divIcon({
                className: 'direction-enabled' + (params.icon_has_halo ? ' has-halo' : ''),
                iconSize: [32, 32],
                html,
            })
        },
        getLocatorUrl() {
            this.locatorUrl = ''
            this.locatorTokenLoading = true

            let host = window.location.origin
            this.locatorUrl = host+'/shipments-locator?name='+this.shipment?.name

            this.locatorTokenLoading = false
/***
            this.$api.shipmentsLocator.getToken({name: this.shipmentID})//timeout: 12*3600
                .then((resp) => {
                    let data = resp.data
                    if (data?.error || !data?.token) {
                        this.toast.warning(this.$t('errors.Token error'))
                        console.error('token error', data)
                        this.locatorUrl = data.message || this.$t('errors.Token error');
                    } else {
                        let host = window.location.origin
                        this.locatorUrl = host+'/shipments-locator?token='+data.token
                    }
                })
                .catch((error) => {
                    console.error(error)
                })
                .finally(() => {
                    this.locatorTokenLoading = false
                })
***/
        },
    }
}
</script>